import React from 'react';
import Chart from 'react-apexcharts';
import { PageHeading } from '../../../../../../SharedComponents';
import '../Styles/Styles.scss';

function BarChart({ data }) {
  const maxLeadCount = Math.max(...data.map((item) => item.claimCount));

  const series = [
    {
      name: 'Actual Leads',
      data: data.map((item) => item.claimCount),
    },
    {
      name: 'Max Capacity',
      data: data.map(() => maxLeadCount),
    },
  ];

  const options = {
    chart: {
      type: 'bar',
      stacked: true,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        columnWidth: '40%',
        borderRadius: 15,
        borderRadiusApplication: 'end',
        dataLabels: {
          position: 'top',
        },
      },
    },
    dataLabels: { enabled: false },
    tooltip: {
      custom: ({ series, seriesIndex, dataPointIndex, w }) => {
        const seriesName = w.globals.seriesNames[seriesIndex];
        if (seriesName === 'Max Capacity') return null;
        const value = series[seriesIndex][dataPointIndex];
        return `<div class="apex-tooltip-custom">${seriesName}: ${value}</div>`;
      },
    },
    xaxis: {
      categories: data.map((item) => item.sourceName),
      labels: { style: { colors: '#000' } },
    },
    yaxis: {
      labels: { style: { colors: '#000' } },
      title: {
        text: 'Claims Count',
        style: { color: '#000' },
      },
    },
    colors: ['#5E4322', '#EAECF0'],
    grid: {
      borderColor: '#f1f1f1',
    },
    legend: { show: false },
    bar: {
      horizontal: false,
    },
  };

  return (
    <div className='chart-card'>
      <PageHeading
        headerTitle={'Claims Per Branch'}
        headerTitleClasses={'card-title'}
        hasDivider
      />
      <Chart
        options={options}
        series={series}
        type='bar'
        height={300}
      />
    </div>
  );
}

export default BarChart;
